import { DownloadButton } from './DownloadButtom';
import { Col, Container, Row } from 'reactstrap';
import { StudentRiskPrimaryFiltersLoaderData } from './hooks/StudentRiskPrimaryFiltersLoader';
import {
  StudentsRiskHistoryLoaderConsumer,
  StudentsRiskHistoryLoaderProvider,
} from './hooks/StudentsRiskHistoryLoader';
import { PrimaryFilters } from './PrimaryFilters';
import { StudentsListTable } from './StudentsListTable';
import { useTexts } from './hooks/useTexts';
import { SectionTitle } from '../../../../components/text';

export function StudentListContainer() {
  const {
    defaultPeriod,
    defaultSchool,
    defaultYear,
  } = StudentRiskPrimaryFiltersLoaderData();
  const texts = useTexts();
  return (
    <StudentsRiskHistoryLoaderProvider
      fetchImmediately
      defaultQuery={{
        items_per_page: 10,
        page: 0,
        periodId: defaultPeriod?.value,
        year: defaultYear.value,
        schoolId: defaultSchool.value,
      }}
    >
      <Container fluid>
        <div className="fs-16">{texts.subtitle}</div>
        <PrimaryFilters />
        <Row className="align-items-end">
          <Col>
            <SectionTitle text={texts.table.title} />
          </Col>
          <Col>
            <DownloadButton />
          </Col>
        </Row>
      </Container>
      <div className="w-100 mt-2 d-flex flex-wrap justify-content-center">
        <StudentsRiskHistoryLoaderConsumer>
          <Container fluid>
            <StudentsListTable />
          </Container>
        </StudentsRiskHistoryLoaderConsumer>
      </div>
    </StudentsRiskHistoryLoaderProvider>
  );
}
